import * as Style from '../../shared/GlobalStyles/styles'

import iconMoney from '../../assets/Delivery/iconPaymentMoney.svg'
import iconPayment from "../../assets/Delivery/iconPaymentCard.svg"
import iconPix from '../../assets/Delivery/iconPix.svg';

export const RenderPayment = ({item}) => {
    if(item.tipo === 1) return <Style.Icon src={iconMoney}/>
    else if (item.tipo === 2 || item.tipo === 3)return <Style.Icon src={iconPayment}/>
    else if(item.tipo === 4 || item.tipo === 5)return <Style.Icon src={iconPix}/>
    return null
}